import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import i18n from './i18n';
import App from './App';
import { findRoute } from './routes';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const path = window.location.pathname;

if (container.hasChildNodes()) {
  // Production: the page was prerendered in Spanish (scripts/prerender.js).
  // Hydrate in Spanish so React adopts that HTML as-is; <App> switches to the
  // visitor's chosen language (?lang= or the switcher) once it has mounted.
  const preferred = i18n.resolvedLanguage || i18n.language;
  const switchTo = findRoute(path).page === 'home' && preferred !== 'es' ? preferred : null;
  if (switchTo) i18n.changeLanguage('es');
  ReactDOM.hydrateRoot(
    container,
    <React.StrictMode>
      <App path={path} switchLanguageTo={switchTo} />
    </React.StrictMode>
  );
} else {
  // Development server: nothing prerendered.
  ReactDOM.createRoot(container).render(
    <React.StrictMode>
      <App path={path} />
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
